// extracted by mini-css-extract-plugin
export default {"cellBox":"P8kmj0cyGgLIRCO5ehXp","goalNotExist":"B3uU7Cllbr_AXN4lTOnE","badGoal":"meNSia81OV45NfY8FaYH","goodGoal":"fKv83rzFWnci4DKsbpIt"};